import { ShippingOptionViewProps } from './shipping-option-view.types'
import styles from './shipping-option-view.module.scss'
import cl from 'classnames'
import {
  Button,
  formatPrice,
  IconDelete,
  IconEdit,
  LabeledLine,
  Text1
} from '@touche-lts/panel-ui/dist'
import { ValueTag } from 'components'

const ShippingOptionViewComponent = (props: ShippingOptionViewProps) => {
  const { className, style, shipping, onEditClick, onRemoveClick } = props

  return (
    <div className={cl(styles.container, className)} style={style}>
      <div>
        <LabeledLine colorPreset='dark' label='Name'>
          {shipping.name} ({shipping.deliveryTime || '-'}{' '}
          {shipping.chronoUnit.toLowerCase()})
        </LabeledLine>
        <LabeledLine colorPreset='dark' label='Price' alignItems='stretch'>
          <div>
            {shipping.freeShipping ? (
              <Text1 colorPreset='dark'>Free shipping</Text1>
            ) : (
              <>
                <Text1 colorPreset='dark'>{formatPrice(shipping.price)}</Text1>
                {shipping.freeShippingAbove && (
                  <Text1 colorPreset='dark'>
                    Free shipping above: {formatPrice(shipping.freeAmount)}
                  </Text1>
                )}
              </>
            )}
          </div>
        </LabeledLine>
        <LabeledLine colorPreset='dark' label='Ships to' alignItems='stretch'>
          <div className={styles.valueTagsContainer}>
            {shipping.countries.map(country => {
              return <ValueTag key={country} valueName={country} />
            })}
          </div>
        </LabeledLine>
      </div>
      <div className={styles.buttonsContainer}>
        <Button
          preset='icon'
          title='Edit shipping option'
          onClick={onEditClick}
        >
          <IconEdit fill={styles.white} />
        </Button>
        <Button
          preset='icon'
          className={styles.deleteCircleIconButton}
          title='Remove shipping option'
          onClick={onRemoveClick}
        >
          <IconDelete />
        </Button>
      </div>
    </div>
  )
}

const ShippingOptionView = ShippingOptionViewComponent
export { ShippingOptionView }
